/**
 * WP10b / #46641 — TanStack stubs for the settings/help/database alias cluster.
 *
 * The map and query-merge live in `verification-legacy-redirects.ts` (pure).
 * These routes exist so unregistered aliases like `/docs` and `/db` match the
 * tree and hop via beforeLoad. Canonical `/settings`, `/help`, `/database` are
 * not registered here. Each `path` is a literal so route-render inventory can
 * see it (the scanner does not follow helpers).
 */

import { createRoute, redirect } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { resolveSettingsHelpDatabaseRedirect } from "./verification-legacy-redirects";

function hopSettingsHelpDatabase(location: { pathname: string; searchStr: string }) {
  const dest = resolveSettingsHelpDatabaseRedirect(location.pathname, location.searchStr);
  if (dest) throw redirect({ to: dest, replace: true });
}

export const settingsPersonalAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/personal",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const settingsAppsAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/apps",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const settingsAdvancedAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/advanced",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const settingsHelpAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/help",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const settingsDatabaseAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/database",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const preferencesAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferences",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const profileAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/profile",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const accountAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/account",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const docsAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/docs",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const documentationAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/documentation",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const helpCenterAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/help-center",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const dbAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/db",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});

export const sqlAliasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sql",
  beforeLoad: ({ location }) => hopSettingsHelpDatabase(location),
});
